import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { twMerge } from '../../utils/twMerge.js';
export const DialogHeader = forwardRef(function DialogHeader(props, forwardedRef) {
    return (_jsx("div", { ...props, ref: forwardedRef, className: twMerge('ppl-DialogHeader flex flex-row items-center justify-between gap-2 py-3 pl-5 pr-3', props.className) }));
});
//# sourceMappingURL=DialogHeader.js.map